<!--
 * @Description: 业绩分成
 * @Author: ChenXueLin
 * @Date: 2021-10-21 13:48:36
 * @LastEditTime: 2021-10-21 13:54:54
 * @LastEditors: ChenXueLin
-->
<template>
  <div>
    <!-- 搜索头部 start -->
    <table-title>
      <template v-slot:searchForm>
        <el-form class="search-list" ref="searchForm" :model="searchForm">
          <el-form-item class="search-item--1" prop="orderNo">
            <el-input
              v-model="searchForm.orderNo"
              placeholder="业务员"
              title="业务员"
            ></el-input>
          </el-form-item>
          <el-form-item class="search-item--1" prop="orderNo">
            <el-input
              v-model="searchForm.orderNo"
              placeholder="分成比例"
              title="分成比例"
            ></el-input>
          </el-form-item>

          <el-form-item class="search-item--buttons">
            <el-button type="primary" @click="handleSearch">查询</el-button>
            <el-button class="reset" @click="handleReset">重置</el-button>
          </el-form-item>
        </el-form>
      </template>
      <template v-slot:operateAction>
        <i class="e6-icon-add_line" title="新增" @click="handleAdd"></i>
        <i class="e6-icon-clear_line" title="删除"></i>
        <i class="e6-icon-export_fill" title="导出"></i>
      </template>
    </table-title>
    <!-- 搜索头部 end -->

    <!-- 表格 start -->
    <section class="table-wrapper">
      <el-table border height="500px" :data="tableData" highlight-current-row>
        <!-- <el-table-column type="selection" width="40"></el-table-column> -->
        <!-- 序号 start -->
        <el-table-column
          label="序号"
          width="50"
          fixed="left"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <span>
              {{
                scope.$index +
                  1 +
                  (searchForm.pageIndex - 1) * searchForm.pageSize
              }}
            </span>
          </template>
        </el-table-column>
        <!-- 序号 end -->
        <el-table-column
          show-overflow-tooltip
          v-for="(column, index) in columnData"
          :key="index"
          :prop="column.fieldName"
          :label="column.fieldLabel"
          :min-width="column.width"
          :fixed="column.fixed"
          :align="column.align"
          header-align="center"
        >
          <template slot-scope="{ row }">
            <span v-if="column.fieldName === 'chargeCode'">
              <el-button type="text" @click="toDetail(row)">
                {{ row[column.fieldName] }}
              </el-button>
            </span>
            <span v-else>{{ row[column.fieldName] }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column
            fixed="right"
            align="center"
            label="操作"
            width="120"
          >
            <template slot-scope="scope">
              <e6-td-operate
                :data="getOperateList()"
                @command="handleOperate($event, scope.row)"
              ></e6-td-operate>
            </template>
          </el-table-column> -->
      </el-table>
    </section>
    <!-- 表格 end -->

    <!-- 分页 start -->
    <section class="pagination-wrapper fixed-section">
      <el-pagination
        :page-size.sync="searchForm.pageSize"
        :current-page.sync="searchForm.pageIndex"
        :page-sizes="pageSizes"
        :layout="layout"
        :total="total"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </section>
    <!-- 分页 end -->
    <!-- 新增弹框 -->
    <el-dialog
      v-dialogDrag
      title="联系人录入"
      :visible.sync="addVisible"
      width="500px"
      :before-close="handleClose"
      :close-on-click-modal="false"
      v-loading="dialogLoading"
      :element-loading-background="loadingBackground"
      custom-class="add-customer-dialog"
    >
      <el-form ref="addForm" label-width="88px" :model="addForm">
        <!--   :rules="addUserRules" -->
        <el-form-item label="业务员" prop="corpName">
          <el-input
            v-model.trim="addForm.corpName"
            placeholder="业务员"
          ></el-input>
        </el-form-item>
        <el-form-item label="分成比例" prop="corpClass">
          <el-input
            v-model.trim="addForm.corpName"
            placeholder="分成比例"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="corpClass">
          <el-input
            v-model.trim="addForm.corpName"
            placeholder="备注"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="dialog-footer" slot="footer">
        <el-button class="cancel">取消</el-button>
        <el-button type="primary">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import base from "@/mixins/base";
import listPage from "@/mixins/list-page";
import listPageReszie from "@/mixins/list-page-resize";
export default {
  name: "workOrderList",
  data() {
    return {
      searchForm: {
        orderNo: "",
        typeId: "",
        secondType: "",
        pageIndex: 1,
        pageSize: 20
      },
      typeList: [
        {
          id: 1,
          label: "任务单"
        },
        {
          id: 2,
          label: "服务单"
        },
        {
          id: 3,
          label: "协同单"
        }
      ],
      total: 0,
      columnData: [
        {
          fieldName: "chargeCode",
          display: true,
          fieldLabel: "业务员",
          width: 160,
          disabled: false,
          fixed: false,
          align: "center"
        },
        {
          fieldName: "invoiceName",
          display: true,
          fieldLabel: "生成比例",
          width: 160,
          disabled: false,
          fixed: false,
          align: "center"
        },
        {
          fieldName: "corpName",
          display: true,
          fieldLabel: "备注",
          width: 160,
          disabled: false,
          fixed: false,
          align: "center"
        }
      ], //表头
      tableData: [
        {
          chargeCode: "11111"
        },
        {
          chargeCode: "155551"
        }
      ], // 表格数据
      addVisible: false,
      addForm: {},
      dialogLoading: false
    };
  },
  mixins: [base, listPage, listPageReszie],

  computed: {},

  mounted() {},

  methods: {
    //点击新增
    handleAdd() {
      this.addVisible = true;
    },
    //关闭弹框
    handleClose() {
      this.addVisible = false;
    }
  }
};
</script>
<style lang="scss" scoped>
/deep/ .add-customer-dialog {
  .el-form {
    padding: 0px 20px;
    .el-input {
      width: 350px;
    }
  }
}
</style>
